interface LoadingScreenProps {
  label?: string
  /** 'page' fills the full viewport; 'section' fills its container with padding */
  variant?: 'page' | 'section'
}

export default function LoadingScreen({ label = 'Loading…', variant = 'page' }: LoadingScreenProps) {
  const isPage = variant === 'page'
  return (
    <div
      className={`flex items-center justify-center font-mono ${
        isPage ? 'h-screen bg-aethex-bg' : 'py-24'
      }`}
    >
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-aethex-primary border-t-transparent animate-spin mx-auto mb-4" />
        <p className="text-xs text-aethex-dim uppercase tracking-widest">{label}</p>
      </div>
    </div>
  )
}
